<p>
  Each print is <i>strictly random</i>, <i>unique</i> (thus signed 1/1), and
  <i>non reproducible</i>.
</p>
<p>
  The artwork is generated completely randomly, among billions of possibilities,
  without any selection by the artist, and then directly printed.
</p>
<p>
  In the production process, the artist does not ever see the image, nor the
  print, makes no review or selection, and at last does not know at all what is
  in the sealed envelope. The artist signs the print blindly.
</p>
<p>
  The artwork is also <i>non reproducible</i> as in the process, the random seed,
  used to generate the artwork, is not kept, nor the computer file containing the
  image. It is not possible to generate or print the same artwork again, which means
  that if the print is lost, or degrades, it will not ever be possible to see it
  again.
</p>
